import { makeStyles, createStyles } from "@material-ui/styles";
import styled from 'styled-components';
import { ThemeContextTypes } from "../../../../data/ThemeContext";

export const useStyles = makeStyles(() => createStyles({
  messageDocument: {
    maxWidth: '270px',
    minWidth: '270px'
  },
  messageWithMedia: {
    maxWidth: '330px',
  },
  messageWithoutMedia: {
    maxWidth: '512px',
  },
  messageWithText: {
    padding: '12px 16px',
  },
  messageWithTextAndMedia: {
    padding: '4px 2px 8px 9px',
  },
  messageWithDocument: {
    padding: '6px 4px 8px 9px',
  },
}));

export const VideoConferenceWrapper = styled.div<{theme?: ThemeContextTypes}>`
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.body?.timeDividerBackgroundColor};
  padding: 10px;
  box-shadow: 0px 1px 0px 0.5px rgba(0, 0, 0 , 0.13);
  border-radius: 7.5px;
  svg{
    color: ${props => props.theme.body?.customer?.sliderTrackColor};
  }
  a{
    text-decoration: underline;
    color: blue;
    cursor: pointer;
  }
`;


export const MessageInfoContainer = styled.div`
  float: right;
  margin: -10px 0px -5px 4px;
  position: relative;
  z-index: 10;
`;

export const MessageInfoContainerWithoutText = styled.div`
  right: 8px;
  position: absolute;
  bottom: 6px;
  z-index: 2;
`;

export const MessageInfo = styled.div`
  font: inherit;
  color: rgba(0, 0, 0, 0.45);
  height: 15px;
  outline: none;
  font-size: 11px;
  line-height: 15px;
  white-space: nowrap;
  vertical-align: initial;
`;

export const MessageInfoWithoutText = styled.div`
  color: rgba(255, 255, 255, .9);
  font-size: 11px;
  height: 15px;
  line-height: 15px;
  white-space: nowrap;
`;

export const MessageHour = styled.span<{hourColor?: string}>`
  display: inline-block;
  vertical-align: top;
  color: ${props => props.hourColor};
`;

export const MessageTextWrapper = styled.div`
  position: relative;
`;

export const MessageTextContent = styled.div<{textColor: string}>`
  display: inline;
  color: ${props => props.textColor};
  user-select: text;
  cursor: text;
  white-space: pre-wrap;
  word-break: break-word;

  a {
    color: ${props => props.textColor};
  }
  a:visited {
    color: ${props => props.textColor};
  }
`;

export const MessageTextSpacer = styled.div`
  vertical-align: middle;
  display: inline-block;
  width: 40px;
`;